import { Injectable } from "@angular/core";
import { Adapter } from "@core/adapter";
import { OrganisationBranchConnectionModel } from "@core/api/models/organisation/organisation.branch.connection.model";
import { BranchAdapter } from "../branch.model";
import { Client, ClientAdapter } from "../client.model";
import { CustomField } from "../customField.model";
import { OrganisationProfileAddress } from "./organisation-profile-address";


export class OrganisationProfile{
  constructor(
    public id:string,
    public name:string,
    public addressBook:OrganisationProfileAddress[],
    public client:Client,
    public fields:CustomField[] = []
  ){}

  setFieldsFromFormValues(formfields:any){
    this.fields.forEach(field => {
      field.value = formfields[field.name];
    });
  }
}


@Injectable({
  providedIn: 'root'
})

export class OrganisationProfileAdapter implements Adapter<OrganisationProfile> {
  constructor(private clientAdapter:ClientAdapter, private branchAdapter:BranchAdapter) {
  }

  adapt(item: any): OrganisationProfile {
    const client = this.clientAdapter.adapt(item.client);
    client.branches = item.branchConnections.map((b:OrganisationBranchConnectionModel) => {
      let branch = this.branchAdapter.adapt(b.branch);
      branch.active = b.active;
      branch.organisationConnectionId = b.id;
      return branch;
    });
    return new OrganisationProfile(
      item.id??"",
      item.name,
      [],
      client,
      []
    );
  }
}
